import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { authAxiosWithBearer, baseURL } from '../../../baseURL'
import AssignedTicketDetailsComponent from '../../Technician/TechnicianComponent/AssignedTicketDetailsComponent'
import AssignedTransportDetailsComponent from '../InHouseComponents/AssignedTransportDetailsComponent'
import AssignedTransportProductReceivedStatusChange from '../InHouseComponents/AssignedTransportProductReceivedStatusChange'
import TransportedProductRcvStatusModalButton from './AssignedTransportComponents/TransportedProductRcvStatus/TransportedProductRcvStatusModalButton'

const AssignedTransportDetails = () => {
    const {id} = useParams()
    const [data, setData]= useState(null)
    const [ticketData, setTicketData] = useState(null);
    const [loading,setLoading] = useState(false)
    const [ticktDataLoading,setTicketDataLoading] = useState(false)

    // fetchDeatilsData
    const fetchDeatilsData = async () => {
        try {
            setLoading(true)
            const response = await authAxiosWithBearer.get(`${baseURL}/in_house/api/assigned-transport-details/${id}/`);
            // console.log('ticket',response.data);
            setData(response.data);
        } catch (error) {
            console.log(error);
        }finally{
            setLoading(false)
        }
    };

    useEffect(() => {
        fetchDeatilsData();
    }, [id]);

    
    // fetchAssignedTicketData
    useEffect(() => {
        const fetchTicketData = async () => {
        try {
            setTicketDataLoading(true)
            const response = await authAxiosWithBearer.get(`${baseURL}/ccd/api/single-assign-view/${data?.assigned_technician}/`);
            // console.log('ticket',response.data);
            setTicketData(response.data);
        } catch (error) {
            console.log(error);
        }finally{
            setTicketDataLoading(false)
        }
        };
        fetchTicketData();
    }, [data]);
    
  return (
    <div>

        <div className="user-details-page-title mb-5 shadow flex justify-between">
            <div className="my-auto py-2">
                <h1 className='uppercase'>Assigned Transport Details</h1>
            </div>
            {data?.transport_assign_status === 'Job Completed' && data?.product_received_status === false &&(
            <div className='py-2'>
                <TransportedProductRcvStatusModalButton 
                id={id} 
                ActionURL={`in_house/api/assigned-transport-product-received-status-change`} 
                redirectURL={'assigned-transport-details'}  
                fetchDetailsData={fetchDeatilsData}
                />
            </div>
            )}
        </div>


            {/* assigned transport details start  */}
                <AssignedTransportDetailsComponent  data={data} loading={loading} />
            {/* assigned transport details end  */}
        
            {/* assigned ticket details start  */}
            <AssignedTicketDetailsComponent loading={ticktDataLoading}  ticketData={ticketData} />
            {/* assigned ticket details end  */}

    </div>
  )
}

export default AssignedTransportDetails